<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
      <div class="p-3">Role Based Access Control</div>
      @if (isDisabled) {
        <button class="btn btn-success btn-sm me-3 mt-3 mb-3" (click)="onEdit()">Edit</button>
      }
      @if (!isDisabled) {
        <button class="btn btn-success btn-sm me-3 mt-3 mb-3" (click)="onSave()">Save</button>
      }
    </div>
  </div>

  <!-- RBAC Table -->
  <div class="container-fluid mt-3">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4 mb-5">
        @if (errorMessage) {
          <div class="mt-2">
            <ngb-alert type="danger" (closed)="errorMessage = '' ">{{ errorMessage }}</ngb-alert>
          </div>
        }
        @if (successMessage) {
          <div class="mt-2">
            <ngb-alert type="success" (closed)="successMessage = '' ">{{ successMessage }}</ngb-alert>
          </div>
        }
        <div class="table-structure">
          @if (dataArray.length === 0) {
            <div class="text-center text-muted py-5">
              <i class="bi bi-shield-exclamation fs-1"></i>
              <p class="mt-2">No RBAC records configured. Please add roles and screens to get started.</p>
            </div>
          } @else {
            <table class="table table-bordered mt-3 altpay-table">
              <thead>
                <tr>
                  <th class="fw-bold">Department</th>
                  <th class="fw-bold">Role</th>
                  @for (sn of screenNames; track sn) {
                    <th class="fw-bold">{{sn}}</th>
                  }
                </tr>
              </thead>
              <tbody>
                <ng-container>
                  @for (item of dataArray; track item) {
                    <tr>
                      <td>{{ item.department }}</td>
                      <td>{{ item.role }}</td>
                      @for (acc of item.access; track acc) {
                        <td class="text-center">
                          <input type="checkbox" [disabled]="isDisabled" [(ngModel)]="acc.access" />
                        </td>
                      }
                    </tr>
                  }
                </ng-container>
              </tbody>
            </table>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Role Management -->
  <div class="container-fluid mt-4">
    <div class="row bg-white p-3">
      <div class="col-md-12">
        <h5 class="mb-3">Role Management</h5>
        <div class="row mb-3">
          <div class="col-md-3">
            <input type="text" class="form-control" placeholder="Role Name" [(ngModel)]="newRoleName">
          </div>
          <div class="col-md-3">
            <input type="text" class="form-control" placeholder="Department" [(ngModel)]="newRoleDepartment">
          </div>
          <div class="col-md-2">
            <button class="btn btn-primary btn-sm" (click)="createRole()">Create Role</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Screen Management -->
  <div class="container-fluid mt-3">
    <div class="row bg-white p-3">
      <div class="col-md-12">
        <h5 class="mb-3">Screen Management</h5>
        <div class="row mb-3">
          <div class="col-md-5">
            <input type="text" class="form-control" placeholder="Screen Name" [(ngModel)]="newScreenName">
          </div>
          <div class="col-md-2">
            <button class="btn btn-primary btn-sm" (click)="createScreen()">Create Screen</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>